"use strict";
exports.__esModule = true;
exports.chart_voronoi_data_Fill = {
  "name": "--pf-chart-voronoi--data--Fill",
  "value": "transparent",
  "var": "var(--pf-chart-voronoi--data--Fill, transparent)"
};
exports["default"] = exports.chart_voronoi_data_Fill;